<template>
  <div class="modal-cademi d-flex flex-column gap-4">
    <snow-select
      v-model="form.product_id"
      id="product-select"
      label="Produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />

    <snow-input
      v-model="form.description"
      id="description"
      label="Descrição da integração (Opcional)"
    />
    <snow-input
      v-model="form.url"
      id="url"
      label="URL de postback"
      :rules="rules.url"
      required
    />

    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        class="order-lg-0 order-1"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        :text="isEdit ? 'Salvar' : 'Integrar'"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
import { required, validUrl } from "@/functions/validation";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["product_id", "url", "status", "description"],
        this.integrationToEdit
      )
    };
  },
  computed: {
    isValid() {
      return this.form.product_id && this.form.url;
    },
    rules() {
      return {
        url: [required(), validUrl()]
      };
    }
  }
};
</script>
